import { Box, CircularProgress, Typography } from '@mui/material';
import { Styles } from 'common/types/styles';
import { ReactElement, useEffect, useState } from 'react';
import { userService } from 'common/services/user.service';
import { RetailerType } from 'common/constants/entities';
import { ButtonWithLoading } from 'common/ui/containers/button-with-loading';
import { PDPGenerationStatus } from 'modules/common/product-details-page/constants';
import { useEstimateCostMutation } from 'common/hooks/api/mutations/use-products-mutation';
import { useModalsContext } from 'modules/common/product-details-page/components/modals-context';

const styles: Styles = {
  btn: { flexGrow: 1 },
  estimatedCost: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    my: 2,
  },
};

interface Props {
  pid: string;
}

export function PdpGenerateArea({ pid }: Props): ReactElement {
  const { pdpLoadingStatus, isGenerating, handleGenerateAI } = useModalsContext();

  const [estimatedCost, setEstimatedCost] = useState<number>(null);

  const { mutate: mutateEstimate, isLoading: isEstimateLoading } = useEstimateCostMutation();

  useEffect(() => {
    if (!userService.ensureRetailer(RetailerType.Flywheel)) return;
    mutateEstimate(
      {
        wpids: [pid],
        optimizeAttributes: true,
        overwriteOptimizedAttributes: true,
        limit: 1,
      },
      {
        onSuccess: value => {
          setEstimatedCost(value);
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pid]);

  return (
    <Box mt={2}>
      {userService.ensureRetailer(RetailerType.Flywheel) && (
        <Box sx={styles.estimatedCost}>
          {isEstimateLoading ? (
            <CircularProgress size={14} />
          ) : (
            <Typography fontSize={14}>
              Estimated Generation Cost: {estimatedCost ? `$${estimatedCost}` : '-'}
            </Typography>
          )}
        </Box>
      )}
      <Box component="span" sx={styles.btn}>
        <ButtonWithLoading
          variant="contained"
          color="primary"
          loading={isGenerating || pdpLoadingStatus !== PDPGenerationStatus.IDLE}
          onClick={handleGenerateAI}
          fullWidth
        >
          Generate
        </ButtonWithLoading>
      </Box>
    </Box>
  );
}
